/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDeveloperAppRequestBody
 */
export interface CreateDeveloperAppRequestBody {
    /**
     * Developer app name
     * @type {string}
     * @memberof CreateDeveloperAppRequestBody
     */
    name: string;
    /**
     * App description
     * @type {string}
     * @memberof CreateDeveloperAppRequestBody
     */
    description?: string;
    /**
     * App logo/image URL
     * @type {string}
     * @memberof CreateDeveloperAppRequestBody
     */
    imageUrl?: string;
    /**
     * Pre-registered OAuth redirect/callback URIs
     * @type {Array<string>}
     * @memberof CreateDeveloperAppRequestBody
     */
    redirectUris?: Array<string>;
}

/**
 * Check if a given object implements the CreateDeveloperAppRequestBody interface.
 */
export function instanceOfCreateDeveloperAppRequestBody(value: object): value is CreateDeveloperAppRequestBody {
    let isInstance = true;
    isInstance = isInstance && "name" in value && value["name"] !== undefined;

    return isInstance;
}

export function CreateDeveloperAppRequestBodyFromJSON(json: any): CreateDeveloperAppRequestBody {
    return CreateDeveloperAppRequestBodyFromJSONTyped(json, false);
}

export function CreateDeveloperAppRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDeveloperAppRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'imageUrl': !exists(json, 'image_url') ? undefined : json['image_url'],
        'redirectUris': !exists(json, 'redirect_uris') ? undefined : json['redirect_uris'],
    };
}

export function CreateDeveloperAppRequestBodyToJSON(value?: CreateDeveloperAppRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'image_url': value.imageUrl,
        'redirect_uris': value.redirectUris,
    };
}

